export const validateProps = (props, keys) => {
  return keys.every(k => props[k] != null);
};
//# sourceMappingURL=PropsValidationUtils.js.map